import { render, staticRenderFns } from "./CareProfilesWidget.vue?vue&type=template&id=af2d1bd8&"
import script from "./CareProfilesWidget.vue?vue&type=script&lang=js&"
export * from "./CareProfilesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports